import { render, staticRenderFns } from "./Subject.modal.vue?vue&type=template&id=2a0e9b1c&"
import script from "./Subject.modal.vue?vue&type=script&lang=js&"
export * from "./Subject.modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports